import { useTranslation } from 'react-i18next';

import { LuClock } from 'react-icons/lu';

import { APP_PAGES } from '../../../../routes/constants';
import { useGetSnoozedEmails } from '../../../../services/snoozedEmails.service';
import { FETCH_POLICY_CACHE_FIRST } from '../../../../utils/constants';
import { SidebarNavLink } from '../SidebarNavLink';

interface SnoozedInboxNavLinkProps {
  isOpen: boolean;
  onNavigate?: () => void;
}

export function SnoozedInboxNavLink({
  isOpen,
  onNavigate,
}: Readonly<SnoozedInboxNavLinkProps>) {
  const { t } = useTranslation();
  const { snoozedEmails } = useGetSnoozedEmails(FETCH_POLICY_CACHE_FIRST);

  return (
    <SidebarNavLink
      icon={LuClock}
      text={t('inbox.sidebar.snoozed')}
      href={APP_PAGES.INBOX_SNOOZED}
      isOpen={isOpen}
      count={snoozedEmails.length}
      onNavigate={onNavigate}
    />
  );
}
